import { render, staticRenderFns } from "./section-highlight.vue?vue&type=template&id=3aaab712&scoped=true"
import script from "./section-highlight.vue?vue&type=script&lang=js"
export * from "./section-highlight.vue?vue&type=script&lang=js"
import style0 from "./section-highlight.vue?vue&type=style&index=0&id=3aaab712&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aaab712",
  null
  
)

export default component.exports